import React, { useEffect, useState } from 'react'
import BASE_URL from '../BASEURL'

const MissionVision = () => {
  const [experience, setExperience] = useState({
    title: '',
    description: '',
  });

  useEffect(() => {
    const fetchExperience = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/experience`);
        if (!res.ok) return;
        const json = await res.json();
        const payload = (json && Array.isArray(json.data) && json.data.length) ? json.data[0] : json;
        setExperience({
          title: payload.title || '',
          description: payload.description || '',
        });
      } catch (err) {
        console.error('Failed to fetch experience data:', err);
      }
    };
    fetchExperience();
  }, []);

  const [vision, setVision] = useState({ title: '', description: '' });
  const [mission, setMission] = useState({ title: '', description: '' });

  useEffect(() => {
    const fetchVisionMission = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/vision-mission`);
        if (!res.ok) return;
        const json = await res.json();
        // API returns: { data: [ {title, description}, ... ] }
        if (json && Array.isArray(json.data)) {
          const missionObj = json.data.find(item => (item.title || '').toLowerCase().includes('mission'));
          const visionObj = json.data.find(item => (item.title || '').toLowerCase().includes('vision'));
          if (missionObj) setMission({ title: missionObj.title, description: missionObj.description });
          if (visionObj) setVision({ title: visionObj.title, description: visionObj.description });
        }
      } catch (err) {
        console.error('Failed to fetch vision/mission data:', err);
      }
    };
    fetchVisionMission();
  }, []);

  return (
    <>
      {/* EXPERIENCE & EXPERTISE */}
      <section className="py-10 " data-aos="fade-up">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary mb-6">
            {experience.title}
          </h2>
          <p className="text-gray-600 font-body leading-relaxed ">
            {experience.description}
          </p>
        </div>
      </section>

      {/* VISION & MISSION */}
      <section className="py-10 ">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10">

          {/* VISION */}
          <div className="bg-gray-50 p-8 rounded-xl shadow-sm hover:bg-primary/5" data-aos="fade-up">
            <h3 className="text-2xl font-heading font-semibold text-primary mb-4">
              {vision.title}
            </h3>
            <p className="text-gray-600 font-body leading-relaxed">
              {vision.description}
            </p>
          </div>

          {/* MISSION */}
          <div className="bg-gray-50 p-8 rounded-xl shadow-sm hover:bg-primary/5" data-aos="fade-up">
            <h3 className="text-2xl font-heading font-semibold text-primary mb-4">
              {mission.title}
            </h3>
            <p className="text-gray-600 font-body leading-relaxed">
              {mission.description}
            </p>
          </div>

        </div>
      </section>
    </>
  )
}

export default MissionVision